import { useEffect, type RefObject } from 'react';

export function useNearScrollEnd(
  scrollRef: RefObject<HTMLElement | null>,
  onNearEnd: () => void,
  options: { thresholdPx?: number; disabled?: boolean } = {},
) {
  const { thresholdPx = 120, disabled = false } = options;

  useEffect(() => {
    const element = scrollRef.current;
    if (!element || disabled) {
      return;
    }

    let ticking = false;

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;

      window.requestAnimationFrame(() => {
        ticking = false;

        const distanceToEnd =
          element.scrollHeight - element.scrollTop - element.clientHeight;

        if (distanceToEnd <= thresholdPx) {
          onNearEnd();
        }
      });
    };

    element.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [disabled, onNearEnd, scrollRef, thresholdPx]);
}
